/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const Nat = require('../types/Nat')
const CElementBase = require('./CElementBase')
const NatObj = require('../types/NatObj')
module.exports = CElementGenerique

function CElementGenerique (listeProprietaire, impProto, estElementFinal) {
  if (arguments.length === 1) CElementBase.call(this, listeProprietaire);
  else {
    CElementBase.call(this, listeProprietaire, impProto, estElementFinal);
  }
  this.nom = "";
  this.elementAssocie = null;
  this.natureGraphique = 0;
  this.natCal = 0;
}
CElementGenerique.prototype = new CElementBase();
CElementGenerique.prototype.constructor = CElementGenerique;
CElementGenerique.prototype.superClass = "CElementBase";
CElementGenerique.prototype.className = "CElementGenerique";

CElementGenerique.prototype.read = function(inps, list){
  this.nom = inps.readUTF();
  var ind = inps.readInt();
  var low = (ind < 32) ? (1 << ind) : 0;
  var high = (ind < 32) ? 0 : (1 << 32 - ind);
  this.natureGraphique = new Nat(low, high);
  ind = inps.readInt();
  low = (ind < 32) ? (1 << ind) : 0;
  high = (ind < 32) ? 0 : (1 << 32 - ind);
  this.natCal = new Nat(low, high);
};

CElementGenerique.prototype.write = function(oups, list){
  oups.writeUTF(this.nom);
  oups.writeInt(this.indiceDeNature(this.natureGraphique));
  oups.writeInt(this.indiceDeNature(this.natCal));
};
// A revoir version mtgApp
/*
CElementGenerique.prototype.adapteNature = function(indiceNatureC) {
  this.natureGraphique = 0;
  this.NatCal = 0;
  switch (indiceNatureC) {
  case 0 :
    this.natureGraphique = mtg32.NatObj.NPointBase;
    break;
  case 1 :
    this.natureGraphique = mtg32.NatObj.NPoint;
    break;
  case 2 :
    this.natureGraphique = mtg32.NatObj.NPointLie;
    break;
  case 3 :
    this.natureGraphique = mtg32.NatObj.NBarycentre;
    break;
  case 4 :
    this.natureGraphique = mtg32.NatObj.NSegment;
    break;
  case 5 :
    this.natureGraphique = mtg32.NatObj.NDroite;
    break;
  case 6 :
    this.natureGraphique = mtg32.NatObj.NVecteur;
    break;
  case 7 :
    this.natureGraphique = mtg32.NatObj.NDemiDroite;
    break;
  case 8 :
    this.natureGraphique = mtg32.NatObj.NCercle;
    break;
  case 9 :
    this.natureGraphique = mtg32.NatObj.NMarqueAngle;
    break;
  case 10 :
    this.natureGraphique = mtg32.NatObj.NValeurAffichee;
    break;
  case 11 :
    this.natureGraphique = mtg32.NatObj.NArc;
    break;
  case 12 :
    this.natureGraphique = mtg32.NatObj.NLieu;
    break;
  case 13 :
    // Attention : Dans la version java, le repère est à la fois graphique (car il doit être affiché) et non graphique
    // Il est considéré comme non graphique car dans les constructions il est choisi en premier dans
    // les objets non graphiques
    this.natureGraphique = mtg32.NatObj.NRepere;
    this.NatCal = NatCal.NRepere;
    break;
  case 14 :
    this.natureGraphique = mtg32.NatObj.NPointDansRepere;
    break;
  case 15 :
    this.natureGraphique = mtg32.NatObj.NCommentaire;
    break;
  case 16 :
    this.natureGraphique = mtg32.NatObj.NPointLiePoint;
    break;
  case 17 :
    this.natureGraphique = mtg32.NatObj.NPolygone;
    break;
  case 18 :
    this.natureGraphique = mtg32.NatObj.NSurface;
    break;
  case 19 :
    this.natureGraphique = mtg32.NatObj.NObjetDuplique;
    break;
  case 20 :
    this.natureGraphique = mtg32.NatObj.NGrapheSuiteRec;
    break;
  case 21 :
    this.natureGraphique = mtg32.NatObj.NBipoint;
    break;
  case 22 :
    this.natureGraphique = mtg32.NatObj.NTransformation;
    break;
  case 23 :
    this.natureGraphique = mtg32.NatObj.NValeurAffichee;
    break;
  case 24 :
    this.NatCal = NatCal.NVariable;
    break;
  case 25 :
    this.NatCal = NatCal.NCalculReel;
    break;
  case 26 :
    this.NatCal = NatCal.NFonction;
    break;
  case 27 :
    this.NatCal = NatCal.NSuiteRecurrenteReelle;
    break;
  case 28 :
    this.natureGraphique = mtg32.NatObj.NMacro;
    break;
  case 29 :
    this.natureGraphique = mtg32.NatObj.NDemiPlan;
    break;
  case 30 :
    this.NatCal = NatCal.NAutreCalcul;
    break;
  case 31 :
    this.natureGraphique = mtg32.NatObj.NLieuDiscret;
    break;
  case 32 :
    this.natureGraphique = mtg32.NatObj.NLigneBrisee;
    break;
  case 33 :
    this.natureGraphique = mtg32.NatObj.NMarqueSegment;
    break;
  case 34 :
    this.natureGraphique = mtg32.NatObj.NImage;
    break;
  case 35 :
    this.natureGraphique = mtg32.NatObj.NLieuObjet;
    break;
  case 36 :
    this.NatCal = NatCal.NCalculComplexe;
    break;
  case 37 :
    this.NatCal = NatCal.NFonctionComplexe;
    break;
  case 38 :
    this.natureGraphique = mtg32.NatObj.NPointParAffixe;
    break;
  case 39 :
    this.NatCal = NatCal.NSuiteRecurrenteComplexe;
    break;
  case 40 :
    this.NatCal = NatCal.NMesureAffixe; // à revoir
    break;
  case 41 :
    this.natureGraphique = mtg32.NatObj.NGrapheSuiteRecComplexe;
    break;
  }
};
*/
CElementGenerique.prototype.getNature = function() {
  return this.natureGraphique;
};
CElementGenerique.prototype.getNatureCalcul = function() {
  return this.NatCal;
};
// A revoir JavaScript
CElementGenerique.prototype.indiceDeNature = function(nature) {
  return NatObj.indiceDeNature(nature);
};
CElementGenerique.prototype.indiceNatureGraphique = function(indice) {
  if (indice < 30)  return indice;
  else return indice - 4;
};
/*
CElementGenerique.prototype.nature = function(indiceNature) {
  if (indiceNature === -1) return 0;
  return 1 << indiceNature;
}
*/




// WEBPACK FOOTER //
// ./src/objets/CElementGenerique.js